// SignupForm.jsx
import { useMemo, useState } from "react";

export default function SignupForm({ branches, onSubmit, loading, error }) {
  const [branchIdx, setBranchIdx] = useState("-1");
  const [id, setId] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const grouped = useMemo(() => {
    const map = {};
    (branches || []).forEach((b) => {
      const area = b.branch_area || "기타";
      (map[area] ||= []).push(b);
    });
    return Object.entries(map);
  }, [branches]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (branchIdx === "-1") return alert("지점을 선택해주세요.");
    if (!id) return alert("아이디를 입력해주세요.");
    if (!password || !passwordConfirm) return alert("비밀번호를 입력해주세요.");
    if (password.length < 4) return alert("비밀번호는 4자 이상이어야 합니다.");
    if (password !== passwordConfirm) return alert("비밀번호가 일치하지 않습니다.");

    onSubmit({
      branch_idx: branchIdx,
      id,
      user_name: userName,
      password,
      phone_number: phone,
      email,
    });
  };

  return (
    <div className="signup">
      <form onSubmit={handleSubmit} className="signupform">
        <div id="content_title">
          <h2>회원가입</h2>
        </div>
  
        <p>지점 선택</p>
        <select value={branchIdx} onChange={(e) => setBranchIdx(e.target.value)}>
          <option value="-1">지점을 선택하세요</option>
          {grouped.map(([area, list]) => (
            <optgroup key={area} label={`-----${area}-----`}>
              {list.map((b) => (
                <option key={b.branch_idx} value={String(b.branch_idx)}>
                  {b.branch_name}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
  
        <p>아이디</p>
        <input value={id} onChange={(e) => setId(e.target.value)} placeholder="아이디" />
  
        <p>비밀번호</p>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="비밀번호" />
  
        <p>비밀번호 확인</p>
        <input type="password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} placeholder="비밀번호 확인" />
  
        <p>이름</p>
        <input value={userName} onChange={(e) => setUserName(e.target.value)} placeholder="이름" />
  
        <p>전화번호</p>
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="010-1234-5678" />
  
        <p>이메일</p>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="이메일" />
  
        <button disabled={loading} className="signupsubmit">{loading ? "가입 중…" : "회원가입"}</button>
        {error && <p className="error">{error}</p>}
  
        <div className="login_link">
          <a href="/login">로그인</a>
        </div>
      </form>
    </div>
  );
}
